// base=/etc/designs/header/clientlibs/desktop/js

/**
 * Legacy Header
 *  - will be replaced by the Responsive Header
 */


// -----------------------------------------------------------------------------
// VENDOR CODE
// -----------------------------------------------------------------------------

import 'etc/designs/header/clientlibs/desktop/js/vendor/jquery/jcookie.js';
import 'etc/designs/header/clientlibs/desktop/js/vendor/dateformat.js';


// -----------------------------------------------------------------------------
// SWISSCOM CODE
// -----------------------------------------------------------------------------
import 'by-category/scs.header.shared.ts';

import 'etc/designs/header/clientlibs/desktop/js/general.js';
import 'etc/designs/header/clientlibs/desktop/js/topnav.js';
import 'etc/designs/header/clientlibs/desktop/js/metanav.js';
import 'etc/designs/header/clientlibs/desktop/js/footer.js';

// -----------------------------------------------------------------------------
// TERRIFIC MODULES - A-Z PLEASE
// -----------------------------------------------------------------------------
// Modern modules (using imports/exports)
const modernTcModules = {
};

// Tc Bootstrap
import { legacyBootstrapDeferredSingleton } from 'bootstrap/load-terrific';
legacyBootstrapDeferredSingleton(modernTcModules);



// WEBPACK FOOTER //
// typescript://../clientlibs/js/by-category/scs.header.ts